module.exports = __webpack_public_path__ + "img/icon-score10.e8e04a01.svg";